export default __webpack_public_path__ + "static/media/change-link-img-ms.e9612e02.svg";